import odeonHelper  from '../helpers/odeon'
import ui, { deliveryVoucherStatuses} from '../ui/odeon'

export default {
    data: () => ({deliveryVoucherStatuses}),
    methods: {
        ...odeonHelper,
        ...ui
    }
}